'use strict';

var cov_1murhee27c = function () {
  var path = '/builds/CS-Development/overlay-messaging/src/main/components/cookies-consent/index.js',
      hash = '875147aa48880c9912060b14a3e189fc1f45980a',
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/builds/CS-Development/overlay-messaging/src/main/components/cookies-consent/index.js',
    statementMap: {
      '0': {
        start: {
          line: 22,
          column: 17
        },
        end: {
          line: 22,
          column: 35
        }
      },
      '1': {
        start: {
          line: 23,
          column: 16
        },
        end: {
          line: 23,
          column: 32
        }
      },
      '2': {
        start: {
          line: 29,
          column: 22
        },
        end: {
          line: 36,
          column: 1
        }
      },
      '3': {
        start: {
          line: 30,
          column: 21
        },
        end: {
          line: 30,
          column: 41
        }
      },
      '4': {
        start: {
          line: 31,
          column: 19
        },
        end: {
          line: 31,
          column: 50
        }
      },
      '5': {
        start: {
          line: 32,
          column: 2
        },
        end: {
          line: 35,
          column: 4
        }
      },
      '6': {
        start: {
          line: 44,
          column: 18
        },
        end: {
          line: 58,
          column: 1
        }
      },
      '7': {
        start: {
          line: 45,
          column: 20
        },
        end: {
          line: 49,
          column: 3
        }
      },
      '8': {
        start: {
          line: 50,
          column: 17
        },
        end: {
          line: 50,
          column: 19
        }
      },
      '9': {
        start: {
          line: 51,
          column: 2
        },
        end: {
          line: 56,
          column: 5
        }
      },
      '10': {
        start: {
          line: 52,
          column: 22
        },
        end: {
          line: 52,
          column: 47
        }
      },
      '11': {
        start: {
          line: 53,
          column: 4
        },
        end: {
          line: 55,
          column: 5
        }
      },
      '12': {
        start: {
          line: 54,
          column: 6
        },
        end: {
          line: 54,
          column: 38
        }
      },
      '13': {
        start: {
          line: 57,
          column: 2
        },
        end: {
          line: 57,
          column: 16
        }
      },
      '14': {
        start: {
          line: 64,
          column: 26
        },
        end: {
          line: 66,
          column: 1
        }
      },
      '15': {
        start: {
          line: 65,
          column: 2
        },
        end: {
          line: 65,
          column: 71
        }
      },
      '16': {
        start: {
          line: 69,
          column: 2
        },
        end: {
          line: 69,
          column: 72
        }
      },
      '17': {
        start: {
          line: 78,
          column: 18
        },
        end: {
          line: 114,
          column: 1
        }
      },
      '18': {
        start: {
          line: 86,
          column: 23
        },
        end: {
          line: 98,
          column: 3
        }
      },
      '19': {
        start: {
          line: 87,
          column: 4
        },
        end: {
          line: 97,
          column: 9
        }
      },
      '20': {
        start: {
          line: 88,
          column: 24
        },
        end: {
          line: 88,
          column: 39
        }
      },
      '21': {
        start: {
          line: 90,
          column: 8
        },
        end: {
          line: 92,
          column: 9
        }
      },
      '22': {
        start: {
          line: 91,
          column: 10
        },
        end: {
          line: 91,
          column: 28
        }
      },
      '23': {
        start: {
          line: 93,
          column: 8
        },
        end: {
          line: 93,
          column: 48
        }
      },
      '24': {
        start: {
          line: 96,
          column: 8
        },
        end: {
          line: 96,
          column: 66
        }
      },
      '25': {
        start: {
          line: 101,
          column: 4
        },
        end: {
          line: 101,
          column: 99
        }
      },
      '26': {
        start: {
          line: 103,
          column: 2
        },
        end: {
          line: 113,
          column: 4
        }
      },
      '27': {
        start: {
          line: 107,
          column: 8
        },
        end: {
          line: 107,
          column: 51
        }
      },
      '28': {
        start: {
          line: 108,
          column: 8
        },
        end: {
          line: 111,
          column: 13
        }
      },
      '29': {
        start: {
          line: 110,
          column: 12
        },
        end: {
          line: 110,
          column: 56
        }
      },
      '30': {
        start: {
          line: 122,
          column: 22
        },
        end: {
          line: 129,
          column: 1
        }
      },
      '31': {
        start: {
          line: 123,
          column: 27
        },
        end: {
          line: 126,
          column: 3
        }
      },
      '32': {
        start: {
          line: 124,
          column: 4
        },
        end: {
          line: 124,
          column: 65
        }
      },
      '33': {
        start: {
          line: 125,
          column: 4
        },
        end: {
          line: 125,
          column: 40
        }
      },
      '34': {
        start: {
          line: 128,
          column: 2
        },
        end: {
          line: 128,
          column: 81
        }
      },
      '35': {
        start: {
          line: 137,
          column: 20
        },
        end: {
          line: 150,
          column: 1
        }
      },
      '36': {
        start: {
          line: 138,
          column: 17
        },
        end: {
          line: 138,
          column: 46
        }
      },
      '37': {
        start: {
          line: 139,
          column: 2
        },
        end: {
          line: 147,
          column: 3
        }
      },
      '38': {
        start: {
          line: 140,
          column: 4
        },
        end: {
          line: 145,
          column: 5
        }
      },
      '39': {
        start: {
          line: 141,
          column: 6
        },
        end: {
          line: 141,
          column: 38
        }
      },
      '40': {
        start: {
          line: 143,
          column: 6
        },
        end: {
          line: 143,
          column: 63
        }
      },
      '41': {
        start: {
          line: 144,
          column: 6
        },
        end: {
          line: 144,
          column: 19
        }
      },
      '42': {
        start: {
          line: 146,
          column: 4
        },
        end: {
          line: 146,
          column: 92
        }
      },
      '43': {
        start: {
          line: 148,
          column: 2
        },
        end: {
          line: 148,
          column: 55
        }
      },
      '44': {
        start: {
          line: 149,
          column: 2
        },
        end: {
          line: 149,
          column: 15
        }
      },
      '45': {
        start: {
          line: 158,
          column: 24
        },
        end: {
          line: 160,
          column: 1
        }
      },
      '46': {
        start: {
          line: 159,
          column: 2
        },
        end: {
          line: 159,
          column: 47
        }
      },
      '47': {
        start: {
          line: 168,
          column: 14
        },
        end: {
          line: 171,
          column: 1
        }
      },
      '48': {
        start: {
          line: 169,
          column: 2
        },
        end: {
          line: 169,
          column: 18
        }
      },
      '49': {
        start: {
          line: 170,
          column: 2
        },
        end: {
          line: 170,
          column: 29
        }
      },
      '50': {
        start: {
          line: 179,
          column: 23
        },
        end: {
          line: 192,
          column: 1
        }
      },
      '51': {
        start: {
          line: 180,
          column: 2
        },
        end: {
          line: 180,
          column: 32
        }
      },
      '52': {
        start: {
          line: 181,
          column: 2
        },
        end: {
          line: 181,
          column: 59
        }
      },
      '53': {
        start: {
          line: 183,
          column: 2
        },
        end: {
          line: 186,
          column: 3
        }
      },
      '54': {
        start: {
          line: 184,
          column: 4
        },
        end: {
          line: 184,
          column: 74
        }
      },
      '55': {
        start: {
          line: 185,
          column: 4
        },
        end: {
          line: 185,
          column: 16
        }
      },
      '56': {
        start: {
          line: 187,
          column: 2
        },
        end: {
          line: 189,
          column: 3
        }
      },
      '57': {
        start: {
          line: 188,
          column: 4
        },
        end: {
          line: 188,
          column: 27
        }
      },
      '58': {
        start: {
          line: 190,
          column: 2
        },
        end: {
          line: 190,
          column: 61
        }
      },
      '59': {
        start: {
          line: 191,
          column: 2
        },
        end: {
          line: 191,
          column: 14
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 29,
            column: 22
          },
          end: {
            line: 29,
            column: 23
          }
        },
        loc: {
          start: {
            line: 29,
            column: 30
          },
          end: {
            line: 36,
            column: 1
          }
        },
        line: 29
      },
      '1': {
        name: 'mapLabels',
        decl: {
          start: {
            line: 44,
            column: 27
          },
          end: {
            line: 44,
            column: 36
          }
        },
        loc: {
          start: {
            line: 44,
            column: 48
          },
          end: {
            line: 58,
            column: 1
          }
        },
        line: 44
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 51,
            column: 20
          },
          end: {
            line: 51,
            column: 21
          }
        },
        loc: {
          start: {
            line: 51,
            column: 30
          },
          end: {
            line: 56,
            column: 3
          }
        },
        line: 51
      },
      '3': {
        name: 'getLangFromConfig',
        decl: {
          start: {
            line: 64,
            column: 35
          },
          end: {
            line: 64,
            column: 52
          }
        },
        loc: {
          start: {
            line: 64,
            column: 55
          },
          end: {
            line: 66,
            column: 1
          }
        },
        line: 64
      },
      '4': {
        name: 'getSportsbookLocale',
        decl: {
          start: {
            line: 68,
            column: 9
          },
          end: {
            line: 68,
            column: 28
          }
        },
        loc: {
          start: {
            line: 68,
            column: 31
          },
          end: {
            line: 70,
            column: 1
          }
        },
        line: 68
      },
      '5': {
        name: 'getLabels',
        decl: {
          start: {
            line: 78,
            column: 27
          },
          end: {
            line: 78,
            column: 36
          }
        },
        loc: {
          start: {
            line: 78,
            column: 47
          },
          end: {
            line: 114,
            column: 1
          }
        },
        line: 78
      },
      '6': {
        name: 'fetchContent',
        decl: {
          start: {
            line: 86,
            column: 32
          },
          end: {
            line: 86,
            column: 44
          }
        },
        loc: {
          start: {
            line: 86,
            column: 50
          },
          end: {
            line: 98,
            column: 3
          }
        },
        line: 86
      },
      '7': {
        name: '(anonymous_7)',
        decl: {
          start: {
            line: 88,
            column: 12
          },
          end: {
            line: 88,
            column: 13
          }
        },
        loc: {
          start: {
            line: 88,
            column: 24
          },
          end: {
            line: 88,
            column: 39
          }
        },
        line: 88
      },
      '8': {
        name: '(anonymous_8)',
        decl: {
          start: {
            line: 89,
            column: 12
          },
          end: {
            line: 89,
            column: 13
          }
        },
        loc: {
          start: {
            line: 89,
            column: 32
          },
          end: {
            line: 94,
            column: 7
          }
        },
        line: 89
      },
      '9': {
        name: '(anonymous_9)',
        decl: {
          start: {
            line: 95,
            column: 12
          },
          end: {
            line: 95,
            column: 13
          }
        },
        loc: {
          start: {
            line: 95,
            column: 20
          },
          end: {
            line: 97,
            column: 7
          }
        },
        line: 95
      },
      '10': {
        name: '(anonymous_10)',
        decl: {
          start: {
            line: 106,
            column: 13
          },
          end: {
            line: 106,
            column: 14
          }
        },
        loc: {
          start: {
            line: 106,
            column: 23
          },
          end: {
            line: 112,
            column: 7
          }
        },
        line: 106
      },
      '11': {
        name: '(anonymous_11)',
        decl: {
          start: {
            line: 109,
            column: 17
          },
          end: {
            line: 109,
            column: 18
          }
        },
        loc: {
          start: {
            line: 109,
            column: 27
          },
          end: {
            line: 111,
            column: 11
          }
        },
        line: 109
      },
      '12': {
        name: 'initListeners',
        decl: {
          start: {
            line: 122,
            column: 31
          },
          end: {
            line: 122,
            column: 44
          }
        },
        loc: {
          start: {
            line: 122,
            column: 47
          },
          end: {
            line: 129,
            column: 1
          }
        },
        line: 122
      },
      '13': {
        name: 'handleMessages',
        decl: {
          start: {
            line: 123,
            column: 36
          },
          end: {
            line: 123,
            column: 50
          }
        },
        loc: {
          start: {
            line: 123,
            column: 58
          },
          end: {
            line: 126,
            column: 3
          }
        },
        line: 123
      },
      '14': {
        name: 'isIOSNative',
        decl: {
          start: {
            line: 137,
            column: 29
          },
          end: {
            line: 137,
            column: 40
          }
        },
        loc: {
          start: {
            line: 137,
            column: 43
          },
          end: {
            line: 150,
            column: 1
          }
        },
        line: 137
      },
      '15': {
        name: 'meetsConditions',
        decl: {
          start: {
            line: 158,
            column: 33
          },
          end: {
            line: 158,
            column: 48
          }
        },
        loc: {
          start: {
            line: 158,
            column: 51
          },
          end: {
            line: 160,
            column: 1
          }
        },
        line: 158
      },
      '16': {
        name: 'start',
        decl: {
          start: {
            line: 168,
            column: 23
          },
          end: {
            line: 168,
            column: 28
          }
        },
        loc: {
          start: {
            line: 168,
            column: 39
          },
          end: {
            line: 171,
            column: 1
          }
        },
        line: 168
      },
      '17': {
        name: 'cookiesOverlay',
        decl: {
          start: {
            line: 179,
            column: 32
          },
          end: {
            line: 179,
            column: 46
          }
        },
        loc: {
          start: {
            line: 179,
            column: 69
          },
          end: {
            line: 192,
            column: 1
          }
        },
        line: 179
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 34,
            column: 4
          },
          end: {
            line: 34,
            column: 69
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 34,
            column: 20
          },
          end: {
            line: 34,
            column: 64
          }
        }, {
          start: {
            line: 34,
            column: 67
          },
          end: {
            line: 34,
            column: 69
          }
        }],
        line: 34
      },
      '1': {
        loc: {
          start: {
            line: 53,
            column: 4
          },
          end: {
            line: 55,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 53,
            column: 4
          },
          end: {
            line: 55,
            column: 5
          }
        }, {
          start: {
            line: 53,
            column: 4
          },
          end: {
            line: 55,
            column: 5
          }
        }],
        line: 53
      },
      '2': {
        loc: {
          start: {
            line: 65,
            column: 9
          },
          end: {
            line: 65,
            column: 70
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 65,
            column: 9
          },
          end: {
            line: 65,
            column: 32
          }
        }, {
          start: {
            line: 65,
            column: 36
          },
          end: {
            line: 65,
            column: 70
          }
        }],
        line: 65
      },
      '3': {
        loc: {
          start: {
            line: 69,
            column: 9
          },
          end: {
            line: 69,
            column: 71
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 69,
            column: 9
          },
          end: {
            line: 69,
            column: 18
          }
        }, {
          start: {
            line: 69,
            column: 22
          },
          end: {
            line: 69,
            column: 42
          }
        }, {
          start: {
            line: 69,
            column: 46
          },
          end: {
            line: 69,
            column: 71
          }
        }],
        line: 69
      },
      '4': {
        loc: {
          start: {
            line: 90,
            column: 8
          },
          end: {
            line: 92,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 90,
            column: 8
          },
          end: {
            line: 92,
            column: 9
          }
        }, {
          start: {
            line: 90,
            column: 8
          },
          end: {
            line: 92,
            column: 9
          }
        }],
        line: 90
      },
      '5': {
        loc: {
          start: {
            line: 101,
            column: 4
          },
          end: {
            line: 101,
            column: 99
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 101,
            column: 4
          },
          end: {
            line: 101,
            column: 12
          }
        }, {
          start: {
            line: 101,
            column: 16
          },
          end: {
            line: 101,
            column: 51
          }
        }, {
          start: {
            line: 101,
            column: 55
          },
          end: {
            line: 101,
            column: 74
          }
        }, {
          start: {
            line: 101,
            column: 78
          },
          end: {
            line: 101,
            column: 99
          }
        }],
        line: 101
      },
      '6': {
        loc: {
          start: {
            line: 139,
            column: 2
          },
          end: {
            line: 147,
            column: 3
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 139,
            column: 2
          },
          end: {
            line: 147,
            column: 3
          }
        }, {
          start: {
            line: 139,
            column: 2
          },
          end: {
            line: 147,
            column: 3
          }
        }],
        line: 139
      },
      '7': {
        loc: {
          start: {
            line: 146,
            column: 11
          },
          end: {
            line: 146,
            column: 91
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 146,
            column: 11
          },
          end: {
            line: 146,
            column: 29
          }
        }, {
          start: {
            line: 146,
            column: 33
          },
          end: {
            line: 146,
            column: 61
          }
        }, {
          start: {
            line: 146,
            column: 65
          },
          end: {
            line: 146,
            column: 91
          }
        }],
        line: 146
      },
      '8': {
        loc: {
          start: {
            line: 181,
            column: 12
          },
          end: {
            line: 181,
            column: 58
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 181,
            column: 12
          },
          end: {
            line: 181,
            column: 36
          }
        }, {
          start: {
            line: 181,
            column: 40
          },
          end: {
            line: 181,
            column: 58
          }
        }],
        line: 181
      },
      '9': {
        loc: {
          start: {
            line: 183,
            column: 2
          },
          end: {
            line: 186,
            column: 3
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 183,
            column: 2
          },
          end: {
            line: 186,
            column: 3
          }
        }, {
          start: {
            line: 183,
            column: 2
          },
          end: {
            line: 186,
            column: 3
          }
        }],
        line: 183
      },
      '10': {
        loc: {
          start: {
            line: 187,
            column: 2
          },
          end: {
            line: 189,
            column: 3
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 187,
            column: 2
          },
          end: {
            line: 189,
            column: 3
          }
        }, {
          start: {
            line: 187,
            column: 2
          },
          end: {
            line: 189,
            column: 3
          }
        }],
        line: 187
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0,
      '34': 0,
      '35': 0,
      '36': 0,
      '37': 0,
      '38': 0,
      '39': 0,
      '40': 0,
      '41': 0,
      '42': 0,
      '43': 0,
      '44': 0,
      '45': 0,
      '46': 0,
      '47': 0,
      '48': 0,
      '49': 0,
      '50': 0,
      '51': 0,
      '52': 0,
      '53': 0,
      '54': 0,
      '55': 0,
      '56': 0,
      '57': 0,
      '58': 0,
      '59': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0
    },
    b: {
      '0': [0, 0],
      '1': [0, 0],
      '2': [0, 0],
      '3': [0, 0, 0],
      '4': [0, 0],
      '5': [0, 0, 0, 0],
      '6': [0, 0],
      '7': [0, 0, 0],
      '8': [0, 0],
      '9': [0, 0],
      '10': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _logger = require('../../logger');

var _logger2 = _interopRequireDefault(_logger);

var _constants = require('./constants');

var _cookieAdapter = require('../../adapters/cookieAdapter');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var moduleMessageBus = void 0;
var publish = void 0;
var logError = (cov_1murhee27c.s[0]++, (0, _logger2.default)('error'));
var logInfo = (cov_1murhee27c.s[1]++, (0, _logger2.default)('log'));
/**
 * forms the correct url language-dependant to get content from
 * @param {string} lang represents the language to retrieve content from ('en-gb', 'de-de'...)
 * @returns {string} url
 */
cov_1murhee27c.s[2]++;
var getContentUrl = function getContentUrl(lang) {
  cov_1murhee27c.f[0]++;

  var currentUrl = (cov_1murhee27c.s[3]++, window.location.href);
  var position = (cov_1murhee27c.s[4]++, currentUrl.search(/-pp(1|2|3)/));
  cov_1murhee27c.s[5]++;
  return (_constants.CRM_COOKIES_CONTENT_URL + '&meta_language=' + lang).replace('--ENV--', position > -1 ? (cov_1murhee27c.b[0][0]++, currentUrl.substring(position, position + 4)) : (cov_1murhee27c.b[0][1]++, ''));
};

/**
 * maps the array that receives as argument to a label object in the form that the cookie-overlay
 * component needs.
 * @param {Array} array containing objects with a property "assetId" that represents the
 * type of the content and a name that represents the content itself
 */
cov_1murhee27c.s[6]++;
var mapLabels = function mapLabels(rawLabels) {
  var _ref;

  cov_1murhee27c.f[1]++;

  var labelsMap = (cov_1murhee27c.s[7]++, (_ref = {}, _defineProperty(_ref, _constants.CRM_COOKIES_TITLE_KEY, 'title'), _defineProperty(_ref, _constants.CRM_COOKIES_BUTTON_KEY, 'button'), _defineProperty(_ref, _constants.CRM_COOKIES_TEXT_KEY, 'text'), _ref));
  var labels = (cov_1murhee27c.s[8]++, {});
  cov_1murhee27c.s[9]++;
  rawLabels.forEach(function (rawObj) {
    cov_1murhee27c.f[2]++;

    var labelType = (cov_1murhee27c.s[10]++, labelsMap[rawObj.assetId]);
    cov_1murhee27c.s[11]++;
    if (labelType) {
      cov_1murhee27c.b[1][0]++;
      cov_1murhee27c.s[12]++;

      labels[labelType] = rawObj.name;
    } else {
      cov_1murhee27c.b[1][1]++;
    }
  });
  cov_1murhee27c.s[13]++;
  return labels;
};

/**
 * finds what language is on site based on wfLanguageConfig.obLanguage
 * @return {string} representing languageCode
 */
cov_1murhee27c.s[14]++;
var getLangFromConfig = function getLangFromConfig() {
  cov_1murhee27c.f[3]++;
  cov_1murhee27c.s[15]++;

  return (cov_1murhee27c.b[2][0]++, window.wfLanguageConfig) && (cov_1murhee27c.b[2][1]++, window.wfLanguageConfig.obLanguage);
};

function getSportsbookLocale() {
  cov_1murhee27c.f[4]++;
  cov_1murhee27c.s[16]++;

  return (cov_1murhee27c.b[3][0]++, window.WH) && (cov_1murhee27c.b[3][1]++, window.WH.sportsbook) && (cov_1murhee27c.b[3][2]++, window.WH.sportsbook.lang);
}

/**
 * tries to fetch the content for the current language, if not available,
 * tries to get the content in english.
 * When it gets content, retrieves the labels and publish the display event
 * @returns {Promise}
 */
cov_1murhee27c.s[17]++;
var getLabels = function getLabels(langCode) {
  cov_1murhee27c.f[5]++;
  cov_1murhee27c.s[18]++;

  /**
   * Fetch the content from the endpoint,
   * if the endpoint is not available or the data that it contains is empty
   * throws an exception
   * @param {string} url where to fetch the content from
   * @return {Promise} containing the data in json format
   */
  var fetchContent = function fetchContent(url) {
    cov_1murhee27c.f[6]++;
    cov_1murhee27c.s[19]++;

    return fetch(url).then(function (response) {
      cov_1murhee27c.f[7]++;
      cov_1murhee27c.s[20]++;
      return response.json();
    }).then(function (_ref2) {
      var Dictionary = _ref2.Dictionary;
      cov_1murhee27c.f[8]++;
      cov_1murhee27c.s[21]++;

      if (Dictionary.length) {
        cov_1murhee27c.b[4][0]++;
        cov_1murhee27c.s[22]++;

        return Dictionary;
      } else {
        cov_1murhee27c.b[4][1]++;
      }
      cov_1murhee27c.s[23]++;
      throw Error('No content in the source');
    }) // If success, display the banner with those labels
    .then(function (data) {
      cov_1murhee27c.f[9]++;
      cov_1murhee27c.s[24]++;

      publish(_constants.MSG_COOKIES_CONSENT_PUB_DISPLAY, mapLabels(data));
    });
  };

  var lang = (cov_1murhee27c.s[25]++, (cov_1murhee27c.b[5][0]++, langCode) || (cov_1murhee27c.b[5][1]++, (0, _cookieAdapter.getItem)(_constants.CRM_COOKIES_LANGUAGE_KEY)) || (cov_1murhee27c.b[5][2]++, getLangFromConfig()) || (cov_1murhee27c.b[5][3]++, getSportsbookLocale()));

  cov_1murhee27c.s[26]++;
  return (
    // We first try to fetch from the current language url
    fetchContent(getContentUrl(lang)) // If error, we log the error and try with english language
    .catch(function (error1) {
      cov_1murhee27c.f[10]++;
      cov_1murhee27c.s[27]++;

      logError('First attempt:', error1.message);
      cov_1murhee27c.s[28]++;
      return fetchContent(getContentUrl('en-gb')) // If error, nothing else to try, log error
      .catch(function (error2) {
        cov_1murhee27c.f[11]++;
        cov_1murhee27c.s[29]++;

        logError('Second attempt:', error2.message);
      });
    })
  );
};
/**
 * Initialses the listeners for the messages sent
 * from the cookies overlay.
 *
 * @returns {void}
 * @private
 */
cov_1murhee27c.s[30]++;
var initListeners = function initListeners() {
  cov_1murhee27c.f[12]++;
  cov_1murhee27c.s[31]++;

  var handleAcceptance = function handleMessages(topic) {
    cov_1murhee27c.f[13]++;
    cov_1murhee27c.s[32]++;

    (0, _cookieAdapter.setItem)(_constants.CRM_COOKIES_CONSENT_KEY, '', 3600 * 24 * 365 * 10); // 10 years
    cov_1murhee27c.s[33]++;
    moduleMessageBus.unsubscribe(topic);
  };

  cov_1murhee27c.s[34]++;
  moduleMessageBus.subscribe(_constants.MSG_COOKIES_CONSENT_SUB_ACCEPTED, handleAcceptance);
};

/**
 * Check if it is native IOS app version >= 10
 *
 * @returns {boolean}  true if it is native IOS app version >= 10.
 * @private
 */
cov_1murhee27c.s[35]++;
var isIOSNative = function isIOSNative() {
  cov_1murhee27c.f[14]++;

  var whDevice = (cov_1murhee27c.s[36]++, (0, _cookieAdapter.getItem)(_constants.CRM_COOKIES_DEVICE));
  cov_1murhee27c.s[37]++;
  if (typeof whDevice !== 'undefined') {
    cov_1murhee27c.b[6][0]++;
    cov_1murhee27c.s[38]++;

    try {
      cov_1murhee27c.s[39]++;

      whDevice = JSON.parse(whDevice);
    } catch (e) {
      cov_1murhee27c.s[40]++;

      logInfo('COOKIE BANNER: could not parce cookie payload');
      cov_1murhee27c.s[41]++;
      return false;
    }
    cov_1murhee27c.s[42]++;
    return (cov_1murhee27c.b[7][0]++, whDevice.is_native) && (cov_1murhee27c.b[7][1]++, whDevice.device_os === 'ios') && (cov_1murhee27c.b[7][2]++, whDevice.app_version >= 10);
  } else {
    cov_1murhee27c.b[6][1]++;
  }
  cov_1murhee27c.s[43]++;
  logInfo('COOKIE BANNER: wh_device cookie not found');
  cov_1murhee27c.s[44]++;
  return false;
};

/**
 * Check if the cookis overlay needs to be displayed.
 *
 * @returns {boolean}         true if the overlay had been already displayed.
 * @private
 */
cov_1murhee27c.s[45]++;
var meetsConditions = function meetsConditions() {
  cov_1murhee27c.f[15]++;
  cov_1murhee27c.s[46]++;

  return !(0, _cookieAdapter.isItemSet)(_constants.CRM_COOKIES_CONSENT_KEY);
};

/**
 * Launchs the cookies overlay.
 *
 * @returns {void}
 * @private
 */
cov_1murhee27c.s[47]++;
var start = function start(langCode) {
  cov_1murhee27c.f[16]++;
  cov_1murhee27c.s[48]++;

  initListeners();
  cov_1murhee27c.s[49]++;
  return getLabels(langCode);
};

/**
 * Entry point for the cookies overlay module.
 *
 * @returns  {void}
 * @public
 */
cov_1murhee27c.s[50]++;
var cookiesOverlay = function cookiesOverlay(messageBus, langCode) {
  cov_1murhee27c.f[17]++;
  cov_1murhee27c.s[51]++;

  moduleMessageBus = messageBus;
  cov_1murhee27c.s[52]++;
  publish = (cov_1murhee27c.b[8][0]++, messageBus.publishSticky) || (cov_1murhee27c.b[8][1]++, messageBus.publish);

  cov_1murhee27c.s[53]++;
  if (isIOSNative()) {
    cov_1murhee27c.b[9][0]++;
    cov_1murhee27c.s[54]++;

    logInfo('COOKIE BANNER: not showing in native IOS app version >= 10');
    cov_1murhee27c.s[55]++;
    return null;
  } else {
    cov_1murhee27c.b[9][1]++;
  }
  cov_1murhee27c.s[56]++;
  if (meetsConditions()) {
    cov_1murhee27c.b[10][0]++;
    cov_1murhee27c.s[57]++;

    return start(langCode);
  } else {
    cov_1murhee27c.b[10][1]++;
  }
  cov_1murhee27c.s[58]++;
  logInfo('COOKIE BANNER: not showing it again, cookie set');
  cov_1murhee27c.s[59]++;
  return null;
};

exports.default = cookiesOverlay;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@wh/overlay-messaging/dist/components/cookies-consent/index.js
// module id = 5
// module chunks = 0